import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";

import { FINDER_CATALOGS } from "./model/finder-copy.ts";
import { FINDER_ERROR_COPY } from "./model/finder-error-copy.ts";

// D206 (ADR-006 §7): every screen and the sidebar entry need "account-finder"; off, the screens are
// the not-found screen and the entry is absent, so the area does not exist for the organization.
export const finderBrowserModule: BrowserModule = defineBrowserModule("finder")
  .withErrorCopy(FINDER_ERROR_COPY)
  .withScreens({
    finder: {
      path: "/account-finder",
      title: phrase(FINDER_CATALOGS, "finderScreenTitle"),
      layout: "app",
      flag: "account-finder",
      load: () => import("./ui/sections/finder-screen.tsx"),
    },
    // The reference keeps its pre-rename route alive; so do we.
    legacy: {
      path: "/influencer-finder",
      title: phrase(FINDER_CATALOGS, "finderScreenTitle"),
      layout: "app",
      flag: "account-finder",
      load: () => import("./ui/sections/finder-screen.tsx"),
    },
    account: {
      path: "/account-finder/:username",
      title: phrase(FINDER_CATALOGS, "accountScreenTitle"),
      layout: "app",
      flag: "account-finder",
      load: () => import("./ui/sections/finder-account-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "accounts",
      group: "leads",
      label: phrase(FINDER_CATALOGS, "navAccounts"),
      href: "/account-finder",
      icon: "search",
      order: 140,
      flag: "account-finder",
    },
  ]);
